import { useContext } from 'react';
import { DataAttributionContext } from '../../context/DataAttributionContext';

/**
 * useDataAttributes
 * @param input populates the attributes with available parameters
 *
 */
export const useDataAttributes = input => {
  const context = useContext(DataAttributionContext);
  const {
    contentCategory,
    contentCategoryId,
    contentPosition,
    location
  } = context || {};
  return { ...input,
    contentCategory,
    contentCategoryId,
    contentPosition,
    location
  };
};